import {
  NEAR_EXPIRY_DAYS,
  permitDaysRemaining,
} from "@/features/ops/ui/components/workerReview";

export function PermitExpiryBadge({ expiresOn }: { expiresOn: string | null }) {
  if (!expiresOn) return null;
  const days = permitDaysRemaining(expiresOn);
  if (days === null) return null;
  const isNear = days <= NEAR_EXPIRY_DAYS;
  const classes = isNear
    ? "border-destructive bg-destructive-light text-destructive-foreground"
    : "border-border bg-surface-sunken text-copy";
  const label =
    days < 0
      ? `Permit expired ${expiresOn}`
      : days === 0
        ? `Permit expires today`
        : isNear
          ? `Permit expires in ${days}d (${expiresOn})`
          : `Permit expires ${expiresOn}`;
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${classes}`}
      title={`Work permit expiry — ${expiresOn}`}
    >
      {label}
    </span>
  );
}

export function SinBadge({ provided }: { provided: boolean }) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${
        provided
          ? "border-success bg-success-light text-success-foreground"
          : "border-border bg-surface-sunken text-copy-muted"
      }`}
      title={
        provided
          ? "SIN encrypted on file. Not displayable — verify against the ID document."
          : "No SIN on file"
      }
    >
      SIN {provided ? "✓ on file" : "—"}
    </span>
  );
}
